import Vue from 'vue';
import Vuex from 'vuex';
import categoria from './modules/categoria';
import postgrado from './modules/postgrado';
import modsede from './modules/sede';
import programa from './modules/programa';
import gestion from './modules/gestion';
import area from './modules/area';
import plataforma from './modules/plataforma';
import concepto from './modules/concepto';
import inscripcion from './modules/inscripcion';
import presupuesto from './modules/presupuesto';
import pago from './modules/pago';
import comision from './modules/comision';
import axios from 'axios';
import { getAccessToken } from '@/accessToken';
import listado from './modules/listado';
import gasto from './modules/gasto';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    categoria,
    postgrado,
    modsede,
    concepto,
    plataforma,
    area,
    gestion,
    programa,
    inscripcion,
    presupuesto,
    pago,
    listado,
    comision,
    gasto,
  },

  state: {
    ID_ROL_LECTURA: 22, //22 es el id del rol del planificador nacional solo tiene acceso de lectura a todo
    isonlyread: true,
    NETSUITE_VISIBLE: true,
    // ======= start data store for templates=======
    UNIDAD_NEGOCIO_ID: null,
    TOKEN: null,
    CONCEPTOS_OPTIONALS: [],
    // programa: null,
    cargo_sede: null,
    sedes: [],
    // ======= end data store for templates=======
    obj: null,
    isLogin: window.localStorage.getItem('TOKEN') != null,
    alertmsg:
      '<br>Presione el boton de continuar si esta seguro que todos los datos proporcionados son correctos, caso contrario vuelva a revisar los datos.<br><br>',
    getMe: null,
    usuario: {},
    roles: [],
    //cargo: [],
    cargo: JSON.parse(window.sessionStorage.getItem('CARGO')),
    menus: [],
    submenus: [],

    DATA_USER: {},
    CARGO: JSON.parse(window.sessionStorage.getItem('XCARGO')),
    MENUS: [],
    CARGOS: [],
    PERMISOS: JSON.parse(window.sessionStorage.getItem('XPERMISOS')),
    apikey_facturacion: null,
    key_facturacion: {},
    unidad: {
      mision: '',
      vision: '',
      logo: '',
      about: '',
      postgrados: '',
      programas: '',
    },
    cajaperturada: false,

    //createPreInscripcion: false, // por defecto si puede inscribir puede pre inscribir
    createInscripcion: true,
    createPostgrado: true,
    updatePostgrado: true,
    createPrograma: true,
    createUsuario: true,
    updateUsuario: true,
    cambiarEstadoUsuario: true,
    cambiarEstadoPostgrado: true,
    getContactosByAsesor: true,
    updatePrograma: true,
    getContactos: true,
    asignarAula: true,
    updateCargo: true,
    cambiarFasePrograma: true,
    cambiarMisDatosAcceso: true,
    cambiarDatosAcceso: true,
    createSemaforoGame: true,
    updateContacto: true,
    deleteInscripcion: true,
    cancelarPagoCuota: true,
    cancelarPagoMatricula: true,
    createArea: true,
    createProfesion: true,
    updateModulo: true,
    updateSede: true,
    cambiarPostgradoStatus: true,
    aprobarPrograma: true,
    subirFasePrograma: true,
    bajarFasePrograma: true,
    createEmpresa: true,
    asignarDocente: true,
    createInstitucion: true,
    cambioInscripcion: true,
    getCertificadoById: true,
    asignarPlataforma: true,
    generarCertificados: true,
    generarRecibo: true,
    getRecibos: true,
    getRecibo: true,
    eliminarRecibo: true,
    asignarCategoriaMoodle: true,
    asignarCourseProgramaModulo: true,
    deletePrograma: true,
    createGrado: true,
    updatePersona: true,
    createCiudad: true,
    updateInstitucion: true,
    updateProfesion: true,
    updateCiudad: true,
    show_rol_select: true,
    CONSWS: {},
  },
  getters: {
    getApiKey(state) {
      return state.apikey_facturacion;
    },
    getKeyFactura(state) {
      return state.key_facturacion;
    },
  },
  mutations: {
    setCargoSedeStore(state, a_cargo_sede) {
      if (!a_cargo_sede.sede) a_cargo_sede.sede = {}; // FIXME: buscar la forma de obtener la unidad de negocio nose donde se usara esto
      const { unidad_negocio } = a_cargo_sede.sede;
      state.UNIDAD_NEGOCIO_ID = unidad_negocio;
      state.cargo_sede = a_cargo_sede;
    },
    setCargosWithSedeStore(state, cargos_with_sede) {
      state.sedes = cargos_with_sede;
    },
    // =====================
    quitarNulos(state) {
      for (var propName in state.obj) {
        if (typeof state.obj[propName] == 'boolean') continue;

        if (state.obj[propName] != null && typeof state.obj[propName] == 'string') {
          state.obj[propName] = state.obj[propName].replace(/\s+/g, ' ');
          if (state.obj[propName].includes('__type')) delete state.obj[propName];
        }

        if (
          state.obj[propName] === null ||
          state.obj[propName] === undefined ||
          state.obj[propName] == '' ||
          (typeof state.obj[propName] != 'string' &&
            typeof state.obj[propName] != 'object' &&
            isNaN(state.obj[propName]))
        ) {
          delete state.obj[propName];
        }
      }
    },
    parseErrores(jsonArray) {
      var obj = JSON.parse(jsonArray);
      var vals = '';
      obj.forEach(function (k) {
        vals += Object.values(k) + '-\n\t';
      });
      return vals;
    },
    async obtenerToknFactura(state) {
      //state.apikey_facturacion = '4265269017';
      let tok = getAccessToken();
      // window.console.log('.........obtenerToknFactura....', tok);
      const apiAxios = axios.create({
        baseURL: '',
        headers: {
          'Content-Type': 'application/json',
          Authorization: tok,
        },
      });

      let idsede = state.CARGO.sede.id;
      let sucursales = await apiAxios
        .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${idsede}`)
        .then(({ data }) => (data.data ? data.data : []));

      // window.console.log('sucursales:',sucursales,idsede);
      let sucursal = {};
      if (sucursales.length > 0) sucursal = sucursales[0];
      if (sucursal.id) {
        /* state.apikey_facturacion = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${sucursal.sucursal.id}`)
          .then(({ data }) => (data.apikey ? data.apikey : '')); */
        let res = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${sucursal.sucursal.id}`)
          .then(({ data }) => data);

        state.apikey_facturacion = res.apikey ? res.apikey : '';
        state.key_facturacion = res;
        // window.console.log('getApiKeyNit::::\n', state.apikey_facturacion);
      } else {
        state.apikey_facturacion = 'La sede seleccionada no tiene sucursal';
        window.console.error('La sede seleccionada no tiene sucursal');
      }
    },
    setConsWs(state, payload) {
      state.CONSWS = payload;
    },
  },
  actions: {
    quitarNulos(context) {
      context.commit('quitarNulos');
    },
    obtenerTokenFactura(context) {
      context.commit('obtenerToknFactura');
    },
  },
});
